import { Component, Prop, getAssetPath, h } from '@stencil/core';
import state from '../../store';
import { Category, CustomerCategory, CustomerSubCategory, Icon } from '../../types';

@Component({
  tag: 'hemfixarna-start',
  shadow: false,
})
export class HemfixarnaGrid {
  @Prop() tree?: Category;
  @Prop() slug?: string;

  isMainCategory(category: CustomerCategory | CustomerSubCategory): category is CustomerCategory {
    return (category as CustomerCategory).show_products !== undefined;
  }

  handleMaleriClick() {
    state.step = 4;
    state.maleri = true;
  }

  render() {
    const maleriLogo = getAssetPath('./assets/gubbe-pensel.svg');
    return state.customer ? (
      <div>
        <h2>{state.selectedCustomerCategory ? state.selectedCustomerCategory.name : 'Alla tjänster'}</h2>
        <div class="hemfixarna_categories--wrapper">
          <ul class="hemfixarna_categories">
            {state.selectedCustomerCategory?.add_painting ? (
              <button onClick={() => this.handleMaleriClick()} class="hemfixarna_maleribox">
                <img height={64} src={maleriLogo} alt="Måleri Logotyp" />
                <p>Beräkna fast pris på måleri & tapetsering här</p>
              </button>
            ) : null}
            {state.selectedCustomerCategory
              ? this.isMainCategory(state.selectedCustomerCategory) && state.selectedCustomerCategory.sub_categories && !state.selectedCustomerCategory.show_products
                ? state.selectedCustomerCategory.sub_categories.map(c => <hemfixarna-box category={c}></hemfixarna-box>)
                : state.selectedCustomerCategory.products
                  ? state.selectedCustomerCategory.products.map(c => <hemfixarna-box category={c.fields}></hemfixarna-box>)
                  : null
              : state.customer.categories.map(c => <hemfixarna-box category={c}></hemfixarna-box>)}
          </ul>
          <hemfixarna-info />
        </div>
      </div>
    ) : (
      <div>
        <h2>Alla tjänster</h2>
        <div class="hemfixarna_categories--wrapper">
          <ul class="hemfixarna_categories">
            {this.tree.sub_cats
              .sort((a, b) => (a.name < b.name ? -1 : 1))
              .map(c => (
                <hemfixarna-box post={c} icon={(c.icon as Icon).url ?? (c.icon as string)} postTitle={c.name}></hemfixarna-box>
              ))}
          </ul>
          <hemfixarna-info />
        </div>
      </div>
    );
  }
}
